import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"inspire"}},[_c('Navigation'),_c('Toolbar'),_c(VContent,[_c(VContainer,{attrs:{"fluid":"","fill-height":""}},[_c(VLayout,[_c(VFlex,{attrs:{"xs12":""}},[_c('Breadcrumbs'),_vm._t("default")],2)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }